const initState = { title: "", body: "", onHide: () => null, animationType: 1 };
const reduceMessage = (state = { ...initState }, action) => {
  switch (action.type) {
    case "SHOW_MESSAGE":
      return {
        ...state,
        title: action.payload.title,
        body: action.payload.body,
        onHide: action.payload.onHide,
        animationType: action.payload.animationType,
      };
    case "HIDE_MESSAGE":
      return { ...initState };
    default:
      return state;
  }
};

export default reduceMessage;
